/** @jsx jsx */
import { jsx } from "@emotion/core"
import PropTypes from "prop-types"
import {
  phoneInputContainerStyles,
  phoneNoBorderContainerStyles,
  loading,
  tickIcon,
  editIcon,
  tickImg,
} from "./styles"
import IntlTelInput from "react-intl-tel-input"
import "react-intl-tel-input/dist/main.css"
import { EditFilled } from "@ant-design/icons"
import loader from "../../assets/images/loader.svg"
import tick from "../../assets/images/icon-tick-2.svg"
import { useEffect, createRef } from "react"

const suffixIcon = (icon, onIconClick) => {
  if (icon === "saved") {
    return (
      <div css={tickIcon} onClick={onIconClick}>
        <img src={tick} alt="saved" css={tickImg} />
      </div>
    )
  } else if (icon === "typing") {
    return <img src={loader} alt="loader" css={loading} />
  } else if (icon === "none") {
    return ""
  }
  return <EditFilled css={editIcon} onClick={onIconClick} />
}

export const PhoneInput = (props) => {
  const { error, icon, onIconClick, autoFocus, ...rest } = props
  let phoneInputRef = createRef(null)

  useEffect(() => {
    if (phoneInputRef.tel) {
      autoFocus && phoneInputRef.tel.focus()
    }
  }, [icon, error])
  return (
    <div
      className="atom-phone-input-container"
      css={phoneInputContainerStyles(error)}
    >
      <IntlTelInput {...rest} ref={(elt) => (phoneInputRef = elt)} />
      {!error && suffixIcon(icon, onIconClick)}
      {error && <span className="error-text">{error}</span>}
    </div>
  )
}

export const PhoneInputNoBorder = (props) => {
  const { ...rest } = props
  return (
    <div
      className="atom-phone-input-border-container"
      css={phoneNoBorderContainerStyles}
    >
      <IntlTelInput fieldId="otp-input" {...rest} />
    </div>
  )
}

PhoneInput.propTypes = {
  /** error string, only to be passed if input is in error state. */
  error: PropTypes.string,
  /** icon to add in input  */
  icon: PropTypes.oneOf(["none", "edit", "saved", "typing"]),
}

PhoneInput.defaultProps = {
  error: "",
  icon: "none",
  parentref: null,
}
